/* jshint node:true */
'use strict';

var createStore = require('fluxible/addons').createStore;
var PersistentStateMixin = require('../mixins/PersistentStateMixin');

var StandingsStore = createStore({
    storeName: 'StandingsStore',

    mixins: [PersistentStateMixin],

    initialize: function() {
        this.data       = {};
        this.loading    = false;
        this.ready      = false;
        this.pathname   = '';
    },

    handlers: {
        RECEIVED_STANDINGS: function(payload) {

            var oGlossary   = {};
            var oClincher   = {};
            var aNotes      = [];
            this._buildAncilleryData(payload.data,oGlossary,aNotes,oClincher);

            this.data.raw         = payload.data;
            this.data.sport       = payload.sport;
            this.data.league      = payload.league;
            this.data.leagueName  = payload.data.name;
            this.data.params      = payload.params;
            this.data.seasons     = this._buildSeasonData(payload.sport,payload.league,payload.data) || [];
            this.data.glossary    = oGlossary;
            this.data.notes       = aNotes;
            this.data.clinchers   = oClincher;
            this.loading          = false;
            this.ready            = true;
            this.pathname         = payload.pathname;

            this.emitChange();
        },
        REQUEST_STANDINGS: function(payload) {
            this.loading = true;
            this.emitChange();
        }
    },

    /*
     * Checks to see if loading if so return false as the store
     * is not ready to allow update
     */
    isReady:function(){
        return this.ready;
    },

    /*
     * Checks to see if the store is loading data
     */
    isUpdating: function(){
        try {
            return this.loading;
        } catch (e) {
            return false;
        }
    },

    getStandings: function() {
        try {
            return this.data || {};
        } catch (e) {
            return {};
        }
    },

    _buildAncilleryData: function(oData,oGlossary,aNotes,oClincher){

        /* itterate the data and pull the descriptions for each column */
        if(typeof oData === "undefined"){
            return {}
        }

        if(typeof oData.children !== "undefined"){
            for (var i = 0; i < oData.children.length; i++) {
                this._buildAncilleryData(oData.children[i],oGlossary,aNotes,oClincher);
            }
        }

        if(typeof oData.standings !== "undefined"){
            this._buildAncilleryData(oData.standings,oGlossary,aNotes,oClincher);
        }

        if (typeof oData.entries !== "undefined"){
            for (var i = 0; i < oData.entries.length; i++) {
                this._buildAncilleryData(oData.entries[i],oGlossary,aNotes,oClincher);
            }
        }

        if (typeof oData.stats !== "undefined"){
            for (var i = 0; i < oData.stats.length; i++) {
                oGlossary[oData.stats[i].type] = oData.stats[i].description;
                if(oData.stats[i].type === 'clincher'){
                   oClincher[oData.stats[i].displayValue] = oData.stats[i].description;
                }
            }
        }

        if (typeof oData.note !== "undefined"){
            aNotes.push(oData.note);
        }

    },

    _buildSeasonData: function(sSport,sLeague,oData){

        /* itterate the data and pull the descriptions for each column */
        if(typeof oData === "undefined" || typeof oData.seasons === "undefined"){
            return [];
        }
        var aSeasons = oData.seasons;

        /* set a year cap */
        var minSeason = {
            'nba':2002,
            'mlb':2002,
            'usa.1':2002,
            'ncf':2002,
            'nfl':2002
        };
        var iMinYear = minSeason[sLeague] || 2002;

        /* itterate seasons data available at the end of the feed and format accordingly. */
        var dToday      = new Date();
        var aTmpSeasons = [];

        for(var i = 0; i < aSeasons.length; i++){
            var oSeason = aSeasons[i];
            if(oSeason.startDate != "" && oSeason.endDate != ""){
                var dStartDate  = new Date(oSeason.startDate);
                var dEndDate    = new Date(oSeason.endDate);

                /* dump all early years */
                if(iMinYear > dStartDate.getFullYear()){
                    continue;
                }

                var sDisplayValue = dStartDate.getFullYear();
                if(sDisplayValue !== dEndDate.getFullYear()){
                    sDisplayValue = dStartDate.getFullYear()+'-'+dEndDate.getFullYear().toString().slice(-2);
                }

                var bIsCurrent = false;
                if(dToday.getTime() >= dStartDate.getTime() && dToday.getTime() <= dEndDate.getTime()){
                    bIsCurrent = true;
                }

                /* itterate the types for this season and build an acceptable list */
                var aTmpTypes = [];
                var iLeagueId = sLeague;
                if(typeof oSeason.types !== "undefined"){
                    for(var v = 0; v < oSeason.types.length; v++){
                        var oType = oSeason.types[v];

                        if(oType.startDate === null || oType.startDate === '' || oType.abbreviation === null || oType.abbreviation === '' || oType.abbreviation === 'off' || oType.abbreviation === 'post'){
                            /* ignored in standings if no or incorrect data */
                            continue;
                        }

                        var dTypeStartDate  = new Date(oType.startDate);
                        var dTypeEndDate    = new Date(oType.endDate);

                        if(dToday.getTime() < dTypeStartDate.getTime()){
                            /* start date in the future so ignore */
                            continue;
                        }

                        var bTypeIsCurrent = false;
                        if(dToday.getTime() >= dTypeStartDate.getTime() && dToday.getTime() <= dTypeEndDate.getTime()){
                            bTypeIsCurrent = true;
                        }

                        aTmpTypes.push({
							id:             oType.id,
							name:           oType.name,
							abbreviation:   oType.abbreviation,
							isCurrent:      bTypeIsCurrent
                        });

                        if(oType.abbreviation === 'reg' && sSport === 'rugby'){
                            iLeagueId = oType.id;
                        }
                    }
                }

                aTmpSeasons.push({
                    displayValue:   sDisplayValue,
                    year:           oSeason.year,
                    isCurrent:      bIsCurrent,
                    types:          aTmpTypes,
                    league:         iLeagueId
                });

            }

        }
        //console.log(aTmpSeasons);
        return aTmpSeasons;
    }

});

module.exports = StandingsStore;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/stores/StandingsStore.js
 **/